import type { GetServerSideProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'

// Components
import HelpHome from '@/components/pages/HelpCenter/components/Home'
import HelpHead from '@/components/pages/HelpCenter/components/HelpHead'

// Libs
import { fetchHelpCollections } from '@/api/fetchHelpCollections'
import { countryQueryOf, getHelpCountry, requireHelpData } from '@/components/pages/HelpCenter/methods'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

// Types
import type { HelpCollectionItem } from '@/api/fetchHelpArticle'

type Props = {
  collections: HelpCollectionItem[]
  countryCode: string
  countryQuery: string | null
}

// _app 以 <Component {...appProps} /> 渲染，getServerSideProps 的資料在 props.pageProps
const HelpCenterHome = ({ pageProps }: { pageProps: Props }) => {
  const { collections, countryCode, countryQuery } = pageProps

  const { t } = useTranslation()

  return (
    <>
      <HelpHead description={t('Help_Center_Hero_Title')} canonicalPath={ROUTE_PATH.HELP} />
      <HelpHome collections={collections} countryCode={countryCode} countryQuery={countryQuery ?? undefined} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ locale, query }) => {
  const countryCode = getHelpCountry(locale, query.country_code)
  const { list } = requireHelpData(await fetchHelpCollections({ countryCode }))

  return {
    props: {
      collections: list ?? [],
      countryCode,
      countryQuery: countryQueryOf(query.country_code) ?? null,
      ...(await serverSideTranslations(locale as string, ['common'])),
    },
  }
}

export default HelpCenterHome
